export default {
  lineNumberColor: `#f8f8f2`,
  lineNumberBgColor: `#2b2b2b`,
  backgroundColor: `#2b2b2b`,
  textColor: `#f8f8f2`,
  substringColor: `#f8f8f2`,
  keywordColor: `#dcc6e0`,
  attributeColor: `#ffd700`,
  selectorAttributeColor: `#dcc6e0`,
  docTagColor: `#f8f8f2`,
  nameColor: `#ffa07a`,
  builtInColor: `#f5ab35`,
  literalColor: `#f5ab35`,
  bulletColor: `#abe338`,
  codeColor: `#f8f8f2`,
  additionColor: `#abe338`,
  regexpColor: `#ffa07a`,
  symbolColor: `#abe338`,
  variableColor: `#ffa07a`,
  templateVariableColor: `#ffa07a`,
  linkColor: `#f5ab35`,
  selectorClassColor: `#ffa07a`,
  typeColor: `#f5ab35`,
  stringColor: `#abe338`,
  selectorIdColor: `#ffa07a`,
  quoteColor: `#d4d0ab`,
  templateTagColor: `#f8f8f2`,
  deletionColor: `#ffa07a`,
  titleColor: `#00e0e0`,
  sectionColor: `#00e0e0`,
  commentColor: `#d4d0ab`,
  metaKeywordColor: `#f8f8f2`,
  metaColor: `#f5ab35`,
  functionColor: `#f8f8f2`,
  numberColor: `#f5ab35`,
};
